const forecastViewType = Object.freeze({
  RollingView: "RollingView",
  BudgetView: "BudgetView",
  FutureView: "FutureView",
  HistoricView: "HistoricView",
});

export default forecastViewType;
